<template>
  <FlatButtonStyle :size="size" :variant="variant" :disabled="disabled">
    <button :type="type" :disabled="disabled">
      <div :class="$style.content">
        <slot name="icon" v-if="$slots.icon" />
        <div v-if="$slots.default" :class="$style.content__text"><slot /></div>
      </div>
    </button>
  </FlatButtonStyle>
</template>

<script lang="ts">
export { sizes, variants } from '@/components/atoms/FlatButtonStyle.vue'
export type { Variant, Size } from '@/components/atoms/FlatButtonStyle.vue'
</script>

<script setup lang="ts">
import type { ButtonHTMLAttributes } from 'vue'
import type { Variant, Size } from '@/components/atoms/FlatButtonStyle.vue'
import FlatButtonStyle from '@/components/atoms/FlatButtonStyle.vue'

withDefaults(
  defineProps<{
    type?: ButtonHTMLAttributes['type']
    size?: Size
    variant?: Variant
    disabled?: boolean
  }>(),
  {
    type: 'button',
    size: 'medium',
    variant: 'primary',
    disabled: false,
  }
)
</script>

<style lang="scss" module>
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
</style>
